module.exports = __webpack_public_path__ + "img/icon-business-card-mobile.69150c65.svg";